
export default {
  Close: '닫기',
  Confirm: '확인',
  header: {
    Home: '홈페이지',
    MyOrder: '나의 주문서',
    Login: '등록',
    changeYourPassword: '패스워드 수정',
    logout: '나가기'
  },
  Announcement: '공지',
  WeChatTitle: '진시황제릉박물원 위챗 공식 계정',
  PleaseUseWeChat: '위챗으로 위 공식 계정 QR코드를 스캐닝하세요',
  CountDown: '카운트다운',
  CountDownComplete: '폐쇄 하 다.',
  buyTicket: {
    selectAVisitDate: '참관 일자 선택',
    selectAVisitTime: '입장권 검사 진입 시간대를 선택하세요',
    selectTicketType: '입장권 유형 선택',
    maxNum: `1회 주문서로 최대 입장권&valItem장 구매`,
    Monday: '월요일',
    Tuesday: '화요일',
    Wednesday: '수요일',
    Thursday: '목요일',
    Friday: '금요일',
    Saturday: '토요일',
    Sunday: '일요일',
    notBooking: '예약 불가',
    ticketBalance: '잔량',
    productName: '제품명',
    ticketType: '입장권 종류',
    ticketingInstructions: '입장권 구매 안내 말씀',
    PleaseRead: '안내 말씀을 잘 읽으셔서 숙지하십시요',
    IRead: '이미 숙지하였습니다. 계속 예약하기',
    UnitPrice: '단가',
    Quantity: '수량',
    noDataAvailable: '데이터가 없습니다',
    telephoneConsultation: '전화 문의',
    onlineConsultation: '온라인 문의',
    weChatOfficialAccount: '위챗 공식 계정',
    Reminder: '제시',
    totalPrice: '총가격',
    placeOrder: '주문서 제출',
    ticketingInstructions: '입장권 구매 안내 말씀',
    Total: '합계',
    totalNum: '총&valItem장',
    TotalPrice: '총가격',
    LatestAnnouncement: '최신 공지',
    viewMore: '더 보기'
  },
  // 购票进程
  TicketingProcessObj: {
    TicketingProcess: '입장권 구매 절차',
    TimeOut: '입장권 검사 진입 시간대 선택',
    selectTicketType: '티켓 유형 선택',
    FillOrder: '주문서 정보 입력',
    OrderPayment: '주문서 지불',
    Completed: '완성'
  },
  // 账号密码登录注册修改
  LoginObj: {
    LoginAndPassword: '계정 패스워드 등록',
    LoginCode: '인증번호 등록',
    PleaseNumber: '핸드폰 번호를 입력하십시요',
    PleasePassword: '패스워드를 입력하십시요',
    Change: '바꾸기',
    PleaseCode: '인증번호를 입력하십시요',
    PleaseAgain: '패스워드를 재입력하십시요',
    LogIn: '즉시 등록',
    SignUpNow: '즉시 로그인',
    ForgotPassword: '패스워드 분실',
    AgreeDisclaimer: '회원 약관과 면책 조항에 동의함',
    GetVerificationCode: '인증 번호 취득하기',
    Reacquire: '재취득하기',
    NoAccount: '계정이 없습니다',
    ChangePassword: '패스워드 수정',
    Logout: '나가기',
    ExistingAccount: '已有账号',
    ImmediatelyFind: '立即找回'
  },
  // 下单页
  FillOrder: {
    FillOrder: '주문서 정보 입력',
    FillOrderTitle: '진시황박물원 입장권 예약 구매시 실명제를 실행합니다. 모든 참관자께서는 신분 정보를 입력하셔야 예약하실 수 있습니다.',
    VisitDate: '참관 일자',
    Name: '이름',
    DocumentType: '신분증서 유형',
    IDCard: '신분증',
    Passport: '여권',
    Others: '기타',
    IDNumber: '증서 번호',
    SpecialIDType: '특수 증서 유형',
    SpecialIDNumber: '특수 증서 번호',
    DeleteThisContact: '해당 연락인 삭제',
    PleaseYourName: '이름을 입력하십시요',
    PleaseIDNumber: '신분증서 번호를 입력하십시요',
    PleaseSpecialIDNumber: '특수 증서 번호 입력하십시요',
    PleaseenterContact: '연락인 핸드폰 번호를 입력하십시요',
    Delete: '삭제',
    information: '연락인 정보',
    informationSub: '（정확하게 입력하셔서 주문서 정보 수신 불가를 방지하십시요）',
    ContactPhoneNumber: '연락 핸드폰 번호',
    TotalAmount: '총금액',
    BuyNow: '즉시 구매',
    ConfirmReminder: '확인 제시',
    DoubleConfirm: '재확인',
    Confirmed: '틀림없음을 확인함',
    BeforeBy: '즉시 구매하기 전에 신분 정보 입력 정확 여부를 확인하시여 고객님의 참관에 영향을 주는 것을 방지하십시요.',
    OutByOrder: '안내 말씀',
    Mausoleum: '진시황제릉박물원이 환영합니다！안내 말씀：매일 시스템 유지보수 시간은 23:30부터 이튿날 02：30까지입니다. 이 시간대에는 입장권 판매 서비스가 일시 중단됩니다.',
    Reminder: '제시 정보',
    PleaseCorrectInformation: '정확한 정보를 입력하십시요',
    AgeDiscountRange: '고객님 나이가 우대 범위에 부합되지 않습니다',
    InvalidIDNumber: '신분증 번호 무효',
    productName: '제품명',
    ticketType: '입장권 종류',
    Quantity: '수량',
    UnitPrice: '단가'
  },
  back: '돌아가기',
  // 支付
  payOrder: {
    OrderQuantity: '주문서 수량',
    NumberProducts: '상품 수량',
    OrderInformation: '주문서 정보',
    VisitTime: '참관 시간',
    TicketName: '입장권 명칭',
    ticketType: '입장권 종류',
    UnitPrice: '단가',
    Quantity: '수량',
    PaymentOrderSeconds: '지불 주문서 남은 시간:&item1분&item2초',
    PleaseComplete: '제때에 완성하십시요. 그렇지 아니하면 주문서가 자동으로 취소됩니다',
    Alipay: '알리페이',
    WeChat: '위챗',
    PleaseQRcodepay: '스캐닝하여 지불하십시요',
    Orderpaymenttimeout: '주문서 지불 시간 초과, 재주문하세요！',
    goFillOrderL: '주문하러 가기',
    Backtohome: '홈페이로 돌아가기',
    Checkorder: '주문서 조회',
    Refund: '환불',
    TicketReplacement: '입장권 재발급',
    ChangeTicket: '변경',
    RefundProgress: '환불 중'
  },
  Cancel: '취소',
  Backtohome: '홈페이로 돌아가기',
  Checkorder: '주문서 조회',
  LatestAnnouncement: '최신 공지',
  PreviousPage: '최신 공지',
  NextPage: '다음 페이지',
  ReleaseTime: '발표 시간',
  MyOrder: {
    MyOrder: '나의 주문서',
    OrderCenter: '주문센터',
    All: '전부',
    Completed: '이미 완성함',
    ToBePaid: '지불 대기 중',
    OrderNumber: '주문서 번호',
    VisitorIDNumber: '참관자 신분증 번호',
    Inquire: '조회',
    Reset: '리셋',
    OrderPlacementTime: '주문 시간',
    Contactphonenumber: '연락인 핸드폰 번호',
    OrderStatus: '주문서 상태',
    Startdate: '시작 일자부터',
    EndDate: '종료 일자',
    VisitTime: '참관 시간',
    Visitdate: '관광 일자',
    VisitTimePeriod: '참관 시간대',
    Actualpaymentpaymentmethod: '실제지불금액/지불 방식',
    Operating: '조작',
    OrderDetails: '주문서 상세 사항',
    Paymentquery: '지불 조회',
    Expandall: '모두 열기',
    CreationDate: '새로 만들기 시간',
    Fullorderamount: '주문서 금액',
    Fullpayment: '실제 지불 금액',
    Fullrefund: '전액 환불',
    Handlingfee: '수수료',
    Ticketnumber: '입장권 번호',
    TicketcheckingQRcode: '입장권 검증 QR코드',
    Effectivedate: '유효 일자',
    Effectivetime: '유효 시간',
    Numberofpeople: '수량',
    Numberoftimes: '횟수',
    Ticketcollectiondate: '입장권 수령 일자',
    Numberofprints: '프린트 횟수',
    Numberofticketschecked: '검증 횟수',
    Ticketstatus: '입장권 상태',
    Checkingrecords: '입장권 검사 기록',
    Uncollectedticket: '입장권 미수령',
    Void: '폐기 처리',
    Checkinrecords: '입장권 검사 기록',
    Close: '닫기',
    Checkininformation: '입장권 검사 정보',
    Ticketidentificationnumber: '입장권 검사 식별 번호',
    Checkindate: '입장권 검사 일자',
    Checkintime: '입장권 검사 시간',
    Checkpointname: '입장권 검사소 명칭',
    Nodataavailable: '조회 데이터 없음',
    Price: '가격',
    Handlingfee: '수수료',
    selectText: '이미&item1장 선택，합계',
    selectText2: '수수료',
    selectVisitTime: '방문 시간을 선택하세요'
  },
  orderStatus: {
    Pendingreview: '심사 대기 중',
    Closed: '이미 닫음',
    Issued: '이미 입장권을 발행함',
    Tobepaid: '지불 대기 중',
    Refunded: '이미 환불함',
    Completed: '이미 완성함'
  },
  status: '상태',
  Ticketcollectionstatus: '입장권 수령 상태',
  Pickedup: '수령함',
  NotPickup: '미수령',
  Ticketcheckintype: '입장권 검사 유형',
  Normalticketcheckin: '입장권 정상 검사',
  Freeadmissionticketcheckin: '무료 입장권 검사',
  Mandatoryticketcheckin: '입장권 강제 검사',
  Ticketcheckmedia: '입장권 검사 매개질',
  Ticketidentificationnumber: '입장권 검사 식별 번호',
  Checkindate: '입장권 검사 일자',
  Checkintime: '입장권 검사 시간',
  Checkpointname: '입장권 검사소 명칭',
  el: {
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共{total}条',
      pageClassifier: '页'
    }
  }
}
